import { useEffect, useState } from 'react'

import { type IServiceRulesWrapper } from '@App/types/servicesTypes'
import { onCheckDisabledConditions } from '@App/utils'

import { AddFields } from './AddFields/AddFields'
import { Buttons } from './Buttons/Buttons'
import style from './RulesOptions.module.scss'

interface IProps {
    serviceRules: IServiceRulesWrapper
    isFetching: boolean
    // setChosen: (chosen: IRuleSection | null) => void
    onChangeRules: (dto: IServiceRulesWrapper, onSuccess?: () => void, withFetching?: boolean) => void
}

export const RulesOptions = (props: IProps) => {
    const { isFetching, serviceRules, onChangeRules } = props
    const [title, setTitle] = useState<string>(serviceRules.sections[0]?.title || '')
    const [description, setDescription] = useState<string>(serviceRules.sections[0]?.description || '')

    useEffect(() => {
        setTitle(serviceRules.sections[0]?.title || '')
        setDescription(serviceRules.sections[0]?.description || '')
    }, [serviceRules.sections])

    const isValidFields = onCheckDisabledConditions(Boolean(description.length > 0), Boolean(!isFetching))

    return (
        <div className={style.container}>
            <AddFields title={title} setTitle={setTitle} description={description} setDescription={setDescription} />
            <Buttons
                onChangeRules={onChangeRules}
                code={serviceRules.code}
                title={title}
                description={description}
                sections={serviceRules.sections}
                isValidFields={isValidFields}
                isFetching={isFetching}
            />
        </div>
    )
}
